var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.96 71.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.57,72H10.38A10.4,10.4,0,0,1,0,61.57V10.38A10.4,10.4,0,0,1,10.38,0H61.57A10.4,10.4,0,0,1,72,10.38V61.57A10.4,10.4,0,0,1,61.57,72ZM10.38,5A5.38,5.38,0,0,0,5,10.38V61.57A5.39,5.39,0,0,0,10.38,67H61.57A5.4,5.4,0,0,0,67,61.57V10.38A5.39,5.39,0,0,0,61.57,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.57,61a8.57,8.57,0,1,1,8.56-8.56A8.58,8.58,0,0,1,19.57,61Zm0-12.13a3.57,3.57,0,1,0,3.56,3.57A3.57,3.57,0,0,0,19.57,48.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.39,61A8.57,8.57,0,1,1,61,52.39,8.57,8.57,0,0,1,52.39,61Zm0-12.13A3.57,3.57,0,1,0,56,52.39,3.57,3.57,0,0,0,52.39,48.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.39,28.13A8.57,8.57,0,1,1,61,19.57,8.57,8.57,0,0,1,52.39,28.13Zm0-12.13A3.57,3.57,0,1,0,56,19.57,3.57,3.57,0,0,0,52.39,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.57,28.13a8.57,8.57,0,1,1,8.56-8.56A8.58,8.58,0,0,1,19.57,28.13Zm0-12.13a3.57,3.57,0,1,0,3.56,3.57A3.57,3.57,0,0,0,19.57,16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourD);
export default __webpack_public_path__ + "static/media/fourD.79e8e362.svg";
export { ForwardRef as ReactComponent };